module.exports = __webpack_public_path__ + "img/linkedin.906d08a7.svg";